import React from 'react';
import {
    getReminderItems,
    getReminderPillClassName,
    getReminderTooltipText,
} from './subparts/appointmentsQuery';

function AppointmentReminderPills({ appointmentStatus }) {
    const reminders = getReminderItems(appointmentStatus || {});

    return (
        <div className="appointments-reminder-pills">
            {reminders.map((reminder) => {
                const tooltipText = getReminderTooltipText(reminder);

                return (
                    <span
                        key={reminder.key}
                        className={`appointments-reminder-pill ${getReminderPillClassName(reminder)}`}
                        tabIndex={0}
                        aria-label={tooltipText}
                    >
                        <span className="appointments-reminder-pill__label">{reminder.shortLabel}</span>
                        {reminder.isSent && (
                            <i
                                className={`bi ${reminder.channelIcon.icon} appointments-reminder-pill__channel`}
                                aria-hidden="true"
                            />
                        )}
                        {reminder.responseStatus && (
                            <span className="appointments-reminder-pill__confirmed" aria-hidden="true">
                                <i className="bi bi-check2" />
                            </span>
                        )}

                        <span className="appointments-reminder-tooltip" role="tooltip">
                            {tooltipText}
                        </span>
                    </span>
                );
            })}
        </div>
    );
}

export default AppointmentReminderPills;
